import { Auth0Provider } from "@auth0/auth0-react";
import { ReactNode } from "react";

interface AuthProviderProps {
    children: ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    return (
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN!}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
            useRefreshTokens={true}  // ✅ Ensures tokens persist
            cacheLocation="localstorage" // ✅ Stores tokens in local storage
            authorizationParams={{
                redirect_uri: window.location.origin + "/share",
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                scope: "openid profile email offline_access"
            }}
        >
            {children}
        </Auth0Provider>
    );
};

export default AuthProvider;
